import { render, staticRenderFns } from "./ElectionsList.vue?vue&type=template&id=958ce33e"
import script from "./ElectionsList.vue?vue&type=script&lang=js"
export * from "./ElectionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports